import { useRef, useEffect, useCallback, DetailedHTMLProps, IframeHTMLAttributes } from "react"

type Props = DetailedHTMLProps<IframeHTMLAttributes<HTMLIFrameElement>, HTMLIFrameElement>

export const ResizableIFrame: React.FC<Props> = (props) => {
    const ref = useRef<HTMLIFrameElement>(null)

    const onMessageReceivedFromIframe = useCallback(
        (e: MessageEvent<{ type: string; height: number; width: number }>) => {
            if (e.data.type != "demetra-iframe-size") return

            const iframe = ref.current
            if (!iframe) return

            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const parent = iframe.parentElement!
            const parentMaxHeight = parent.getBoundingClientRect().height

            const iframeHeight = e.data.height
            iframe.style.height = Math.min(iframeHeight, parentMaxHeight) + "px"
        },
        [],
    )

    useEffect(() => {
        window.addEventListener("message", onMessageReceivedFromIframe)
        return () => window.removeEventListener("message", onMessageReceivedFromIframe)
    }, [onMessageReceivedFromIframe])

    return <iframe {...props} ref={ref} height="500" scrolling="true"></iframe>
}
